/**
 * ink-revolution-shopify.js
 * Shopify-specific JS: cart count, predictive search, header scroll behavior
 */

(function () {
  'use strict';

  /* ============================================================
     1. Cart count (Shopify /cart.js)
  ============================================================ */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var qty = cart.item_count;
        var badge = document.getElementById('cart_quantity');
        var cartLi = document.getElementById('globalMenu--cart');
        if (!badge) return;
        if (qty > 0) {
          badge.style.display = 'inline-block';
          badge.textContent = qty;
          if (cartLi) cartLi.classList.add('is-productIn');
        } else {
          badge.style.display = 'none';
          if (cartLi) cartLi.classList.remove('is-productIn');
        }
      })
      .catch(function () {});
  }

  /* ============================================================
     2. Predictive search (Shopify /search/suggest.json)
  ============================================================ */
  var searchInput = document.querySelector('input[name="keySiteSearch"]');
  var resultBox   = document.getElementById('resultBox');
  var makerSelect = document.getElementById('siteSearchMaker');

  var searchTimer;
  var reqCount   = 0;
  var reqStart   = Date.now();
  var MAX_RPM    = 40;

  function searchSite() {
    if (!searchInput || !resultBox) return;

    var now = Date.now();
    if (now - reqStart > 60000) { reqStart = now; reqCount = 0; }
    if (reqCount >= MAX_RPM) return;

    var word   = searchInput.value.trim();
    var maker  = makerSelect ? makerSelect.value : '0';

    if (!word) {
      resultBox.innerHTML = '';
      return;
    }

    reqCount++;

    /* Build query: prepend maker tag if selected */
    var q = word;
    var makerMap = {
      '1': 'epson',  '2': 'canon', '5': 'brother',
      '6': 'hp',     '7': 'ricoh', '10': 'nec',
      '11': 'fujixerox', '13': 'oki', '99': 'other'
    };
    if (maker && maker !== '0' && makerMap[maker]) {
      q = makerMap[maker] + ' ' + q;
    }

    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = data.resources && data.resources.results && data.resources.results.products;
        if (!products || products.length === 0) {
          resultBox.innerHTML = '<div class="searchResult__none">検索結果がありません</div>';
          return;
        }
        var html = '<ul class="searchResult__list">';
        products.forEach(function (p) {
            console.log(p)
          var price = p.price ? formatPrice(p.price) : '';
          html += '<li class="searchResult__item">' +
            '<a href="' + p.url + '" class="searchResult__link">' +
            (p.image ? '<img src="' + p.image + '" alt="' + escHtml(p.title) + '" width="60" height="60" loading="lazy">' : '') +
            '<span class="searchResult__info">' +
              '<span class="searchResult__title">' + escHtml(p.title) + '</span>' +
              (price ? '<span class="searchResult__price">税込 ' + price + '円</span>' : '') +
            '</span>' +
            '</a></li>';
        });
        html += '</ul>';
        resultBox.innerHTML = html;
      })
      .catch(function () {
        resultBox.innerHTML = '';
      });
  }

  function closeBox() {
    if (resultBox) resultBox.innerHTML = '';
  }

  function formatPrice(cents) {
    return Math.round(cents).toLocaleString('ja-JP');
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Debounce on input */
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(searchSite, 300);
    });
    searchInput.addEventListener('click', searchSite);

    /* Close on outside click */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#searchBox__printerName') &&
          !e.target.closest('#resultBox')) {
        closeBox();
      }
    });
  }

  if (makerSelect) {
    makerSelect.addEventListener('change', searchSite);
  }

  /* Expose globally for legacy inline calls */
  window.searchSite = searchSite;
  window.closeBox   = closeBox;

  /* ============================================================
     3. Sticky header scroll behavior
     (replaces the inline window.onscroll in toppage_pc.html)
  ============================================================ */
  var headerNavi       = document.getElementById('header-navi-ink');
  var globalNavBottom  = document.getElementById('global-navBottom');
  var headerNaviTop    = 0;
  var headerNaviMove   = 0;
  var headerNaviMoveTmp = false;

  function onScrollHeader() {
    if (!headerNavi) return;
    var offsetTop = headerNavi.offsetTop;
    if (!headerNaviTop) headerNaviTop = offsetTop;

    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    if (headerNavi.style.display === 'none') {
      if (headerNaviMoveTmp !== false) {
        headerNaviMove += Math.abs(headerNaviMoveTmp - scrollTop);
      }
      headerNaviMoveTmp = scrollTop;
      if (headerNaviMove > 200) {
        headerNavi.style.display = '';
      }
    }

    if (offsetTop === 0 && scrollTop <= headerNaviTop) {
      headerNavi.className = '';
      if (globalNavBottom) globalNavBottom.className = 'globalInfo';
    } else if (scrollTop > offsetTop) {
      /* scrolled past header - add sticky class if desired */
    } else {
      headerNavi.className = '';
      if (globalNavBottom) globalNavBottom.className = 'globalInfo';
    }
  }

  window.addEventListener('scroll', onScrollHeader, { passive: true });

  /* ============================================================
     4. Init on DOMContentLoaded
  ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    updateCartCount();
  });

  /* Re-sync cart count after Shopify cart changes */
  document.addEventListener('cart:updated', updateCartCount);
  document.addEventListener('ink:cart:count-changed', updateCartCount);
  /* ============================================================
     5. Link login GIỮ query hiện tại  (data-ink-login-keep-query)
  ============================================================
     Liquid KHÔNG đọc được query string, nên `{% render 'login-url' %}` chỉ dựng được
     `return_to` từ `request.path`. Với `/pages/product-review-form?product=…&pid=…` thì
     sau khi login khách quay về form MẤT 2 tham số đó → `product-review-form.js` đọc
     `location.search` ra rỗng và POST `product_id: 0`, tức mất sản phẩm cần đánh giá
     Vì vậy: đánh dấu link bằng `data-ink-login-keep-query` rồi để JS
     ghi lại href kèm nguyên query + `ink_login=1` (toast「※ログインしました。」).

     Path login PHẢI là `/customer_authentication/login` — KHÔNG `routes.account_login_url`
     (absolute URL → Shopify bật sang authentication portal và mất return_to).
  */
  function applyLoginReturnTo() {
    var links = document.querySelectorAll('a[data-ink-login-keep-query]');
    if (!links.length) return;

    var params = new URLSearchParams(window.location.search);
    params.set('ink_login', '1');
    /* Giữ cả `#hash` — cùng lý do như `require-login`: link header trỏ
       `/pages/mypage#navi_buy` / `#navi_myprinter`, mất hash là khách rơi về đầu trang */
    var back = window.location.pathname + '?' + params.toString() + window.location.hash;

    for (var i = 0; i < links.length; i++) {
      links[i].href = '/customer_authentication/login?return_to=' + encodeURIComponent(back);
    }
  }

  document.addEventListener('DOMContentLoaded', applyLoginReturnTo);
  /* Khối gate login có thể do JS render sau (vd guest gate của form review) */
  document.addEventListener('ink:login-links:refresh', applyLoginReturnTo);

  /* ============================================================
     6. Mã giới thiệu 紹介コード  (?itr= / ?itrId=)
  ============================================================
     Link giới thiệu mang `itrId` (32 ký tự) + `type` (ps_introduction.php:122);
     Joomla xử lý ngay lúc ĐĂNG KÝ (introduction.receiver.php). Trên Shopify việc
     đăng ký do Shopify lo nên theme chỉ giữ mã lại trong localStorage (TTL 30 ngày)
     cho flow claim (POST /referral/claim) — hiện KHÔNG có UI claim trên theme.

     Chạy ở JS global vì link giới thiệu có thể trỏ vào BẤT KỲ trang nào. */
  var REFERRAL_KEY = 'ink_referral';
  var REFERRAL_TTL_MS = 30 * 24 * 60 * 60 * 1000;

  function captureReferral() {
    var params = new URLSearchParams(window.location.search);
    var itr = (params.get('itr') || params.get('itrId') || '').trim();
    /* itr_id: chuỗi md5 (ps_introduction.php:89), API giới hạn 32 ký tự */
    if (!/^[A-Za-z0-9]{1,32}$/.test(itr)) return;

    try {
      localStorage.setItem(REFERRAL_KEY, JSON.stringify({
        itr: itr,
        type: (params.get('type') || '').trim().slice(0, 32),
        exp: Date.now() + REFERRAL_TTL_MS,
      }));
    } catch (e) {
      /* Storage đầy / bị chặn → mất mã, khách vẫn gõ tay được ở 会員情報 */
      console.warn('referral: lưu mã giới thiệu fail', e);
    }
  }

  captureReferral();

})();
